import { render, staticRenderFns } from "./CartItemAmount.vue?vue&type=template&id=0765e5fc&"
import script from "./CartItemAmount.js?vue&type=script&lang=js&"
export * from "./CartItemAmount.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CartItemAmount.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcart%2FCartItemAmount%2FCartItemAmount.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports